// import React, { useEffect, useState } from "react";
// import createInstance from "../../../api/axiosinstance";
// import { useSelector } from "react-redux";

// const SampleOrg = () => {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const [interviewList, setInterviewList] = useState([]);
//   const aiDishaApi = createInstance("DISHA");
//   const organizationId = user?.organizationId;
//   const [dashData, setDashData] = useState();
//   const [performanceData, setPerformanceData] = useState({
//     technical_knowledge: 0,
//     problem_solving: 0,
//     communication_skills: 0,
//     culture_fit: 0,
//   });

//   useEffect(() => {
//     getInterviewList();
//     DashboardData();
//     getPerformanceData();
//   }, []);

//   const getInterviewList = async () => {
//     console.log("BEFORE API CALL");
//     await aiDishaApi
//       .get(`/get_Scheduled_interviews_detail?organization_id=${organizationId}`)
//       .then((response) => {
//         setInterviewList(response.data);
//         console.log("interviews", response.data);
//       })
//       .catch((error) => {
//         console.log("Error fetching the interviews", error);
//       });
//   };

//   const DashboardData = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         `/Org-dashboard-values/?org_id=${organizationId}`
//       );
//       console.log("dash data", response.data);
//       setDashData(response.data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const getPerformanceData = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         `/hr_dashboard?organization_id=${organizationId || "ORGID000002"}`
//       );
//       console.log("performance data", response.data);
//       if (
//         response.data.average_graph_val &&
//         response.data.average_graph_val.length > 0
//       ) {
//         const scores = response.data.average_graph_val[0].average_scores;
//         setPerformanceData({
//           technical_knowledge: scores.technical_knowledge || 0,
//           problem_solving: scores.problem_solving || 0,
//           communication_skills: scores.communication_skills || 0,
//           culture_fit: scores.culture_fit || 0,
//         });
//       }
//     } catch (error) {
//       console.log("Error fetching performance data", error);
//     }
//   };

//   // Calculate bar heights based on scores (scale 0-5 to 0-80px)
//   const calculateBarHeight = (score) => {
//     // Convert score (0-5 scale) to height (0-80px scale)
//     return Math.min(80, Math.max(0, score * 16)); // 16px per point, max 80px
//   };

//   return (
//     <div style={{ boxShadow: "-16px -9px 19px -8px rgba(0,0,0,0.75)" }}>
//       <svg
//         width="100%"
//         height="100%"
//         viewBox="0 0 800 600"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <defs>
//           <linearGradient id="a" x1="0%" y1="0%" x2="100%" y2="100%">
//             <stop offset="0%" stop-color="#f8f9fa" />
//             <stop offset="50%" stop-color="#e9ecef" />
//             <stop offset="100%" stop-color="#f8f9fa" />
//           </linearGradient>
//           <linearGradient id="g" x1="0%" y1="0%" x2="0%" y2="100%">
//             <stop offset="0%" stop-color="#4361ee" />
//             <stop offset="100%" stop-color="#4361ee" stop-opacity=".6" />
//           </linearGradient>
//           <linearGradient id="h" x1="0%" y1="0%" x2="0%" y2="100%">
//             <stop offset="0%" stop-color="#3a86ff" stop-opacity=".9" />
//             <stop offset="100%" stop-color="#3a86ff" stop-opacity=".7" />
//           </linearGradient>
//           <linearGradient id="i" x1="0%" y1="0%" x2="0%" y2="100%">
//             <stop offset="0%" stop-color="#3a86ff" stop-opacity=".8" />
//             <stop offset="100%" stop-color="#3a86ff" stop-opacity=".6" />
//           </linearGradient>
//           <linearGradient id="j" x1="0%" y1="0%" x2="0%" y2="100%">
//             <stop offset="0%" stop-color="#3a86ff" stop-opacity=".7" />
//             <stop offset="100%" stop-color="#3a86ff" stop-opacity=".5" />
//           </linearGradient>
//           <linearGradient id="k" x1="0%" y1="0%" x2="0%" y2="100%">
//             <stop offset="0%" stop-color="#3a86ff" stop-opacity=".6" />
//             <stop offset="100%" stop-color="#3a86ff" stop-opacity=".4" />
//           </linearGradient>
//           <linearGradient id="l" x1="0%" y1="0%" x2="0%" y2="100%">
//             <stop offset="0%" stop-color="#3a86ff" stop-opacity=".5" />
//             <stop offset="100%" stop-color="#3a86ff" stop-opacity=".3" />
//           </linearGradient>
//           <linearGradient id="m" x1="0%" y1="0%" x2="0%" y2="100%">
//             <stop offset="0%" stop-color="#3a86ff" stop-opacity=".4" />
//             <stop offset="100%" stop-color="#3a86ff" stop-opacity=".2" />
//           </linearGradient>
//           <filter id="b" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
//             <feColorMatrix
//               in="blur"
//               values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 12 -6"
//               result="glassmorphism"
//             />
//             <feComposite
//               in="SourceGraphic"
//               in2="glassmorphism"
//               operator="atop"
//             />
//           </filter>
//           <filter id="c" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="2" result="blur" />
//             <feFlood flood-color="#4361ee" flood-opacity=".3" result="glow" />
//             <feComposite
//               in="glow"
//               in2="blur"
//               operator="in"
//               result="coloredBlur"
//             />
//             <feComposite in="SourceGraphic" in2="coloredBlur" />
//           </filter>
//           <filter id="e" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="2" result="blur" />
//             <feFlood flood-color="#06d6a0" flood-opacity=".3" result="glow" />
//             <feComposite
//               in="glow"
//               in2="blur"
//               operator="in"
//               result="coloredBlur"
//             />
//             <feComposite in="SourceGraphic" in2="coloredBlur" />
//           </filter>
//           <filter id="d" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="2" result="blur" />
//             <feFlood flood-color="#3a86ff" flood-opacity=".3" result="glow" />
//             <feComposite
//               in="glow"
//               in2="blur"
//               operator="in"
//               result="coloredBlur"
//             />
//             <feComposite in="SourceGraphic" in2="coloredBlur" />
//           </filter>
//           <filter id="f" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="2" result="blur" />
//             <feFlood flood-color="#f9c74f" flood-opacity=".3" result="glow" />
//             <feComposite
//               in="glow"
//               in2="blur"
//               operator="in"
//               result="coloredBlur"
//             />
//             <feComposite in="SourceGraphic" in2="coloredBlur" />
//           </filter>
//         </defs>
//         <path fill="url(#a)" d="M0 0h800v600H0z" />

//         <g transform="translate(40 30)">
//           <rect
//             width="170"
//             height="100"
//             rx="10"
//             ry="10"
//             fill="rgba(255, 255, 255, 0.8)"
//             filter="url(#b)"
//             stroke="#4361ee"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="15" fill="#4361ee80" filter="url(#c)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="16"
//             fill="#4361ee"
//             text-anchor="middle"
//           >
//             👤
//           </text>
//           <text x="60" y="25" font-family="Arial" font-size="12" fill="#495057">
//             Total Interviews
//           </text>
//           <text
//             x="70"
//             y="55"
//             font-family="Arial"
//             font-size="20"
//             font-weight="bold"
//             fill="#000"
//           >
//             {interviewList ? interviewList.length : 0}
//           </text>
//           <text x="70" y="75" font-family="Arial" font-size="12" fill="#06d6a0">
//             ↑ +12%
//           </text>
//         </g>
//         <g transform="translate(230 30)">
//           <rect
//             width="170"
//             height="100"
//             rx="10"
//             ry="10"
//             fill="rgba(255, 255, 255, 0.8)"
//             filter="url(#b)"
//             stroke="#3a86ff"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="15" fill="#3a86ff80" filter="url(#d)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="16"
//             fill="#3a86ff"
//             text-anchor="middle"
//           >
//             X
//           </text>
//           <text x="60" y="25" font-family="Arial" font-size="12" fill="#495057">
//             Cancelled
//           </text>
//           <text
//             x="70"
//             y="55"
//             font-family="Arial"
//             font-size="20"
//             font-weight="bold"
//             fill="#000"
//           >
//             {dashData?.Cancelled_interviews || 0}
//           </text>
//           <text x="70" y="75" font-family="Arial" font-size="12" fill="#06d6a0">
//             ↑ +5%
//           </text>
//         </g>
//         <g transform="translate(420 30)">
//           <rect
//             width="170"
//             height="100"
//             rx="10"
//             ry="10"
//             fill="rgba(255, 255, 255, 0.8)"
//             filter="url(#b)"
//             stroke="#06d6a0"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="15" fill="#06d6a080" filter="url(#e)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="16"
//             fill="#06d6a0"
//             text-anchor="middle"
//           >
//             📅
//           </text>
//           <text x="60" y="25" font-family="Arial" font-size="12" fill="#495057">
//             Scheduled
//           </text>
//           <text
//             x="70"
//             y="55"
//             font-family="Arial"
//             font-size="20"
//             font-weight="bold"
//             fill="#000"
//           >
//             {dashData?.scheduled || 0}
//           </text>
//           <text x="70" y="75" font-family="Arial" font-size="12" fill="#06d6a0">
//             ↑ +8%
//           </text>
//         </g>
//         <g transform="translate(610 30)">
//           <rect
//             width="180"
//             height="100"
//             rx="10"
//             ry="10"
//             fill="rgba(255, 255, 255, 0.8)"
//             filter="url(#b)"
//             stroke="#f9c74f"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="15" fill="#f9c74f80" filter="url(#f)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="16"
//             fill="#f9c74f"
//             text-anchor="middle"
//           >
//             🔁
//           </text>
//           <text x="60" y="25" font-family="Arial" font-size="12" fill="#495057">
//             Resheduled
//           </text>
//           <text
//             x="70"
//             y="55"
//             font-family="Arial"
//             font-size="20"
//             font-weight="bold"
//             fill="#000"
//           >
//             {dashData?.Rescheduled_interviews || 0}
//           </text>
//           <text x="70" y="75" font-family="Arial" font-size="12" fill="#ef476f">
//             ↓ -3%
//           </text>
//         </g>
//         <g transform="translate(40 150)">
//           <rect
//             width="360"
//             height="180"
//             rx="10"
//             ry="10"
//             fill="rgba(255, 255, 255, 0.8)"
//             filter="url(#b)"
//             stroke="#4361ee"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="15" fill="#4361ee80" filter="url(#c)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="14"
//             fill="#4361ee"
//             text-anchor="middle"
//           >
//             📊
//           </text>
//           <text
//             x="60"
//             y="35"
//             font-family="Arial"
//             font-size="14"
//             font-weight="bold"
//             fill="#000"
//           >
//             Interview Performance
//           </text>
//           <path stroke="#495057" d="M50 150h260M50 150V70" />

//           {/* Updated bars with actual API data */}
//           <rect
//             x="70"
//             y={150 - calculateBarHeight(performanceData.technical_knowledge)}
//             width="30"
//             height={calculateBarHeight(performanceData.technical_knowledge)}
//             rx="5"
//             ry="5"
//             fill="url(#g)"
//           />
//           <rect
//             x="120"
//             y={150 - calculateBarHeight(performanceData.communication_skills)}
//             width="30"
//             height={calculateBarHeight(performanceData.communication_skills)}
//             rx="5"
//             ry="5"
//             fill="url(#g)"
//           />
//           <rect
//             x="170"
//             y={150 - calculateBarHeight(performanceData.problem_solving)}
//             width="30"
//             height={calculateBarHeight(performanceData.problem_solving)}
//             rx="5"
//             ry="5"
//             fill="url(#g)"
//           />
//           <rect
//             x="220"
//             y={150 - calculateBarHeight(performanceData.culture_fit)}
//             width="30"
//             height={calculateBarHeight(performanceData.culture_fit)}
//             rx="5"
//             ry="5"
//             fill="url(#g)"
//           />

//           {/* Score labels above bars */}
//           <text
//             x="85"
//             y={145 - calculateBarHeight(performanceData.technical_knowledge)}
//             font-family="Arial"
//             font-size="10"
//             fill="#000"
//             text-anchor="middle"
//           >
//             {performanceData.technical_knowledge.toFixed(1)}
//           </text>
//           <text
//             x="135"
//             y={145 - calculateBarHeight(performanceData.communication_skills)}
//             font-family="Arial"
//             font-size="10"
//             fill="#000"
//             text-anchor="middle"
//           >
//             {performanceData.communication_skills.toFixed(1)}
//           </text>
//           <text
//             x="185"
//             y={145 - calculateBarHeight(performanceData.problem_solving)}
//             font-family="Arial"
//             font-size="10"
//             fill="#000"
//             text-anchor="middle"
//           >
//             {performanceData.problem_solving.toFixed(1)}
//           </text>
//           <text
//             x="235"
//             y={145 - calculateBarHeight(performanceData.culture_fit)}
//             font-family="Arial"
//             font-size="10"
//             fill="#000"
//             text-anchor="middle"
//           >
//             {performanceData.culture_fit.toFixed(1)}
//           </text>

//           <text
//             x="85"
//             y="165"
//             font-family="Arial"
//             font-size="10"
//             fill="#495057"
//             text-anchor="middle"
//           >
//             Tech
//           </text>
//           <text
//             x="135"
//             y="165"
//             font-family="Arial"
//             font-size="10"
//             fill="#495057"
//             text-anchor="middle"
//           >
//             Comm
//           </text>
//           <text
//             x="185"
//             y="165"
//             font-family="Arial"
//             font-size="10"
//             fill="#495057"
//             text-anchor="middle"
//           >
//             Problem
//           </text>
//           <text
//             x="235"
//             y="165"
//             font-family="Arial"
//             font-size="10"
//             fill="#495057"
//             text-anchor="middle"
//           >
//             Culture
//           </text>

//           {/* Y-axis labels */}
//           <text
//             x="45"
//             y="70"
//             font-family="Arial"
//             font-size="8"
//             fill="#495057"
//             text-anchor="end"
//           >
//             5
//           </text>
//           <text
//             x="45"
//             y="90"
//             font-family="Arial"
//             font-size="8"
//             fill="#495057"
//             text-anchor="end"
//           >
//             4
//           </text>
//           <text
//             x="45"
//             y="110"
//             font-family="Arial"
//             font-size="8"
//             fill="#495057"
//             text-anchor="end"
//           >
//             3
//           </text>
//           <text
//             x="45"
//             y="130"
//             font-family="Arial"
//             font-size="8"
//             fill="#495057"
//             text-anchor="end"
//           >
//             2
//           </text>
//           <text
//             x="45"
//             y="150"
//             font-family="Arial"
//             font-size="8"
//             fill="#495057"
//             text-anchor="end"
//           >
//             1
//           </text>
//         </g>
//         <g transform="translate(420 150)">
//           <rect
//             width="360"
//             height="180"
//             rx="10"
//             ry="10"
//             fill="rgba(255, 255, 255, 0.8)"
//             filter="url(#b)"
//             stroke="#06d6a0"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="15" fill="#06d6a080" filter="url(#e)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="14"
//             fill="#06d6a0"
//             text-anchor="middle"
//           >
//             📈
//           </text>
//           <text
//             x="60"
//             y="35"
//             font-family="Arial"
//             font-size="14"
//             font-weight="bold"
//             fill="#000"
//           >
//             Interview Count panel wise
//           </text>
//           <g transform="translate(180 100)">
//             {dashData &&
//               (() => {
//                 const total =
//                   (dashData.total_tech_panel_no || 0) +
//                   (dashData.total_hr_no || 0) +
//                   (dashData.total_manager_no || 0);
//                 if (total === 0) return null; // Handle zero total case

//                 const toRadians = (degrees) => (degrees * Math.PI) / 180;
//                 const techAngle = (dashData.total_tech_panel_no / total) * 360;
//                 const hrAngle = (dashData.total_hr_no / total) * 360;
//                 const managerAngle = (dashData.total_manager_no / total) * 360;

//                 const techEnd = {
//                   x: 50 * Math.cos(toRadians(techAngle)),
//                   y: 50 * Math.sin(toRadians(techAngle)),
//                 };
//                 const hrEnd = {
//                   x: 50 * Math.cos(toRadians(techAngle + hrAngle)),
//                   y: 50 * Math.sin(toRadians(techAngle + hrAngle)),
//                 };
//                 const managerEnd = {
//                   x:
//                     50 *
//                     Math.cos(toRadians(techAngle + hrAngle + managerAngle)),
//                   y:
//                     50 *
//                     Math.sin(toRadians(techAngle + hrAngle + managerAngle)),
//                 };

//                 const techLargeArc = techAngle > 180 ? 1 : 0;
//                 const hrLargeArc = hrAngle > 180 ? 1 : 0;
//                 const managerLargeArc = managerAngle > 180 ? 1 : 0;

//                 const techPath = `M 0 0 L 50 0 A 50 50 0 ${techLargeArc} 1 ${techEnd.x.toFixed(
//                   2
//                 )} ${techEnd.y.toFixed(2)} z`;
//                 const hrPath = `M 0 0 L ${techEnd.x.toFixed(
//                   2
//                 )} ${techEnd.y.toFixed(
//                   2
//                 )} A 50 50 0 ${hrLargeArc} 1 ${hrEnd.x.toFixed(
//                   2
//                 )} ${hrEnd.y.toFixed(2)} z`;
//                 const managerPath = `M 0 0 L ${hrEnd.x.toFixed(
//                   2
//                 )} ${hrEnd.y.toFixed(
//                   2
//                 )} A 50 50 0 ${managerLargeArc} 1 ${managerEnd.x.toFixed(
//                   2
//                 )} ${managerEnd.y.toFixed(2)} z`;

//                 return (
//                   <>
//                     <path d={techPath} fill="#4361ee" />
//                     <path d={hrPath} fill="#3a86ff" />
//                     <path d={managerPath} fill="#06d6a0" />
//                     <circle r="25" fill="rgba(255, 255, 255, 0.7)" />
//                   </>
//                 );
//               })()}
//           </g>
//           <path fill="#4361ee" d="M50 162h8v10H50z" />
//           <text
//             x="60"
//             y="170"
//             font-family="Arial"
//             font-size="10"
//             fill="#495057"
//           >
//             Tech panel[{dashData?.total_tech_panel_no || 0 }]
//           </text>
//           <path fill="#06d6a0" d="M140 162h8v10h-8z" />
//           <text
//             x="150"
//             y="170"
//             font-family="Arial"
//             font-size="10"
//             fill="#495057"
//           >
//             Managerial[{dashData?.total_manager_no||0}]
//           </text>
//           <path fill="#3a86ff" d="M235 162h8v10h-8z" />
//           <text
//             x="245"
//             y="170"
//             font-family="Arial"
//             font-size="10"
//             fill="#495057"
//           >
//             HR[{dashData?.total_hr_no||0}]
//           </text>
//         </g>
//         <g transform="translate(40 350)">
//           <rect
//             width="730"
//             height="240"
//             rx="10"
//             ry="10"
//             fill="rgba(255, 255, 255, 0.8)"
//             filter="url(#b)"
//             stroke="#3a86ff"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="15" fill="#3a86ff80" filter="url(#d)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="14"
//             fill="#3a86ff"
//             text-anchor="middle"
//           >
//             🔍
//           </text>
//           <text
//             x="60"
//             y="35"
//             font-family="Arial"
//             font-size="14"
//             font-weight="bold"
//             fill="#000"
//           >
//             Recruitment Funnel
//           </text>

//           {/* New Funnel Visualization with Reduced Spacing */}
//           <g transform="translate(365 70)">
//             <path
//               d="M-200 0 L200 0 L150 30 L-150 30 Z"
//               fill="url(#h)"
//               stroke="#3a86ff"
//               stroke-width="1"
//             />
//             <path
//               d="M-150 30 L150 30 L100 60 L-100 60 Z"
//               fill="url(#i)"
//               stroke="#3a86ff"
//               stroke-width="1"
//             />
//             <path
//               d="M-100 60 L100 60 L50 90 L-50 90 Z"
//               fill="url(#j)"
//               stroke="#3a86ff"
//               stroke-width="1"
//             />
//             <path
//               d="M-50 90 L50 90 L20 120 L-20 120 Z"
//               fill="url(#k)"
//               stroke="#3a86ff"
//               stroke-width="1"
//             />
//             <path
//               d="M-20 120 L20 120 L10 150 L-10 150 Z"
//               fill="#006400"
//               stroke="#006400"
//               stroke-width="1"
//             />

//             <text
//               x="-225"
//               y="0"
//               font-family="Arial"
//               font-size="12"
//               font-weight="bold"
//               fill="#000"
//               text-anchor="end"
//             >
//               Applications ({dashData?.total_applications || 0})
//             </text>
//             <path stroke="#495057" d="M-225 0 L-200 0" />

//             <text
//               x="-225"
//               y="30"
//               font-family="Arial"
//               font-size="12"
//               font-weight="bold"
//               fill="#8B4513"
//               text-anchor="end"
//             >
//               First Round ({dashData?.first_round || 0})
//             </text>
//             <path stroke="#495057" d="M-225 30 L-150 30" />

//             <text
//               x="-225"
//               y="60"
//               font-family="Arial"
//               font-size="12"
//               font-weight="bold"
//               fill="#000"
//               text-anchor="end"
//             >
//               HR Round ({dashData?.hr_round || 0})
//             </text>
//             <path stroke="#495057" d="M-225 60 L-100 60" />

//             <text
//               x="-225"
//               y="90"
//               font-family="Arial"
//               font-size="12"
//               font-weight="bold"
//               fill="#8B4513"
//               text-anchor="end"
//             >
//               Manager Round ({dashData?.manager_round || 0})
//             </text>
//             <path stroke="#495057" d="M-225 90 L-50 90" />

//             <text
//               x="225"
//               y="135"
//               font-family="Arial"
//               font-size="12"
//               font-weight="bold"
//               fill="#006400"
//               text-anchor="start"
//             >
//               Hired ({dashData?.total_hire || 0})
//             </text>
//             <path stroke="#495057" d="M20 135 L220 135" />
//           </g>
//         </g>
//       </svg>
//     </div>
//   );
// };

// export default SampleOrg;


















































import React, { useState, useEffect } from "react";
import {
  Box, Grid, Card, CardContent, Typography, Chip, LinearProgress,
  Divider, IconButton, Tooltip, Avatar, Stack, Paper, Skeleton, Alert, Button,
} from "@mui/material";
import {
  EventNote, CheckCircleOutline, RecordVoiceOver, GroupsOutlined,
  ManageAccountsOutlined, RefreshOutlined, ErrorOutlineOutlined,
  TrendingUp, CancelOutlined, LoopOutlined, PersonAddAlt1Outlined,
  ThumbDownOutlined, AssignmentTurnedInOutlined, PieChartOutlined,
  LayersOutlined,
} from "@mui/icons-material";
import { useThemeMode } from "../../Themes/ThemeContextTemp";
import createInstance from "../../../api/axiosinstance";

// ─── Safe empty structure ─────────────────────────────────────────────────────
const EMPTY_DATA = {
  organization_id: "",
  "total Interviews": 0,
  scheduled: 0,
  completed_rounds: 0,
  completion_rate_percentage: 0,
  total_applications: 0,
  first_round: 0,
  Second_round: 0,
  hr_round: 0,
  manager_round: 0,
  total_hire: 0,
  total_rejected: 1,
  total_tech_panel_no: 0,
  total_hr_no: 0,
  total_manager_no: 0,
  Cancelled_interviews: 0,
  Rescheduled_interviews: 0,
};

const mapOrgData = (api = {}) => ({
  organization_id:           api.organization_id             ?? "",
  total_interviews:          api["total Interviews"]         ?? 0,
  scheduled:                 api.scheduled                   ?? 0,
  completed_rounds:          api.completed_rounds            ?? 0,
  completion_rate_percentage: api.completion_rate_percentage ?? 0,
  total_applications:        api.total_applications          ?? 0,
  first_round:               api.first_round                 ?? 0,
  second_round:              api.Second_round                ?? 0,
  hr_round:                  api.hr_round                    ?? 0,
  manager_round:             api.manager_round               ?? 0,
  total_hire:                api.total_hire                  ?? 0,
  total_rejected:            api.total_rejected              ?? 0,
  total_tech_panel_no:       api.total_tech_panel_no         ?? 0,
  total_hr_no:               api.total_hr_no                 ?? 0,
  total_manager_no:          api.total_manager_no            ?? 0,
  cancelled_interviews:      api.Cancelled_interviews        ?? 0,
  rescheduled_interviews:    api.Rescheduled_interviews      ?? 0,
});

// ─── Skeleton card ────────────────────────────────────────────────────────────
function MetricCardSkeleton({ COLORS }) {
  return (
    <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3 }}>
      <Box sx={{ height: 3, background: COLORS.border, borderRadius: "12px 12px 0 0" }} />
      <CardContent sx={{ p: 2.2 }}>
        <Skeleton width="60%" height={14} sx={{ mb: 1 }} />
        <Skeleton width="40%" height={36} sx={{ mb: 0.5 }} />
        <Skeleton width="80%" height={12} />
      </CardContent>
    </Card>
  );
}

// ─── KPI Card ─────────────────────────────────────────────────────────────────
function MetricCard({ label, value, sub, icon: Icon, accentColor, COLORS }) {
  return (
    <Card elevation={0} sx={{
      background: COLORS.cardBg, border: `1px solid ${COLORS.border}`,
      borderRadius: 3, height: "100%", overflow: "hidden",
      transition: "transform 0.18s, box-shadow 0.18s",
      "&:hover": { transform: "translateY(-2px)", boxShadow: `0 6px 24px ${accentColor}22` },
    }}>
      <Box sx={{ height: 3, background: accentColor, borderRadius: "12px 12px 0 0" }} />
      <CardContent sx={{ p: 2.2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mb: 0.6, letterSpacing: 0.3 }}>{label}</Typography>
            <Typography sx={{ fontSize: 28, fontWeight: 700, color: COLORS.text, lineHeight: 1 }}>{value}</Typography>
            {sub && <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mt: 0.8 }}>{sub}</Typography>}
          </Box>
          <Avatar sx={{ width: 38, height: 38, borderRadius: 2, background: `${accentColor}18` }}>
            <Icon sx={{ fontSize: 18, color: accentColor }} />
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
}

// ─── Section label ────────────────────────────────────────────────────────────
function SectionLabel({ children, COLORS }) {
  return (
    <Typography sx={{
      fontSize: 10, fontWeight: 700, letterSpacing: 1,
      color: COLORS.card_txt_color, textTransform: "uppercase", mb: 1.2, mt: 0.5,
    }}>{children}</Typography>
  );
}

// ─── Round Progress Row ───────────────────────────────────────────────────────
function RoundRow({ label, value, max, color, COLORS }) {
  const pct = max > 0 ? Math.round((value / max) * 100) : 0;
  return (
    <Box sx={{ mb: 1.4 }}>
      <Stack direction="row" justifyContent="space-between" mb={0.4}>
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: COLORS.text }}>{label}</Typography>
        <Chip label={value} size="small"
          sx={{ height: 18, fontSize: 10, fontWeight: 700, background: `${color}18`, color }} />
      </Stack>
      <LinearProgress variant="determinate" value={pct} sx={{
        height: 7, borderRadius: 4,
        backgroundColor: "rgba(128,128,128,0.12)",
        "& .MuiLinearProgress-bar": { background: color, borderRadius: 4 },
      }} />
    </Box>
  );
}

// ─── Donut-style completion rate ──────────────────────────────────────────────
function CompletionGauge({ pct, accent, COLORS }) {
  const r = 40, c = 2 * Math.PI * r;
  const dash = (pct / 100) * c;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Box sx={{ position: "relative", width: 96, height: 96 }}>
        <svg width="96" height="96" style={{ transform: "rotate(-90deg)" }}>
          <circle cx="48" cy="48" r={r} fill="none" stroke="rgba(128,128,128,0.12)" strokeWidth="10" />
          <circle cx="48" cy="48" r={r} fill="none" stroke={accent} strokeWidth="10"
            strokeDasharray={`${dash} ${c - dash}`} strokeLinecap="round"
            style={{ transition: "stroke-dasharray 0.8s ease" }} />
        </svg>
        <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
          display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography sx={{ fontSize: 16, fontWeight: 800, color: COLORS.text }}>{pct}%</Typography>
        </Box>
      </Box>
      <Box>
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: COLORS.text }}>Completion Rate</Typography>
        <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mt: 0.4 }}>
          Interviews completed vs scheduled
        </Typography>
      </Box>
    </Box>
  );
}

// ─── Main Dashboard ───────────────────────────────────────────────────────────
export default function OrgAdminDashboard() {
  const { COLORS, theme, toggleTheme } = useThemeMode();
  const axiosInstance = createInstance("DISHA"); // adjust instance key as needed

  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  // Replace "ORGID000001" with however you get the org id in your app
  const ORG_ID = "ORGID000001";

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axiosInstance.get(`/Org-dashboard-values/?org_id=${ORG_ID}`);
      setData(mapOrgData(response.data));
    } catch (err) {
      console.error("Org dashboard fetch error:", err);
      setError("Unable to load dashboard data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchDashboard(); }, []);

  const d = data ?? mapOrgData(EMPTY_DATA);

  const accent = theme === "dark" ? "#e6b450" : "rgb(37,99,235)";
  const purple = "#7c3aed";
  const teal   = "#0d9488";
  const green  = "#16a34a";
  const amber  = "#d97706";
  const red    = "#dc2626";

  const maxRound = Math.max(d.first_round, d.second_round, d.hr_round, d.manager_round, 1);

  const kpiCards = [
    { label: "Total Interviews",    value: d.total_interviews,          sub: "All interview records",                   icon: EventNote,                 color: accent  },
    { label: "Scheduled",           value: d.scheduled,                 sub: "Awaiting interview",                      icon: AssignmentTurnedInOutlined, color: purple  },
    { label: "Completed Rounds",    value: d.completed_rounds,          sub: "Rounds finished",                         icon: CheckCircleOutline,         color: green   },
    { label: "Total Applications",  value: d.total_applications,        sub: "Candidates applied",                      icon: PersonAddAlt1Outlined,      color: teal    },
    { label: "Total Hired",         value: d.total_hire,                sub: "Offer accepted",                          icon: TrendingUp,                 color: green   },
    { label: "Total Rejected",      value: d.total_rejected,            sub: "Did not proceed",                         icon: ThumbDownOutlined,          color: red     },
  ];

  const panelStats = [
    { label: "Tech Panel Members",  value: d.total_tech_panel_no, color: accent,  icon: GroupsOutlined         },
    { label: "HR Panel Members",    value: d.total_hr_no,         color: purple,  icon: RecordVoiceOver        },
    { label: "Manager Panel",       value: d.total_manager_no,    color: teal,    icon: ManageAccountsOutlined },
  ];

  const roundRows = [
    { label: "First Round",   value: d.first_round,   color: accent  },
    { label: "Second Round",  value: d.second_round,  color: purple  },
    { label: "HR Round",      value: d.hr_round,      color: teal    },
    { label: "Manager Round", value: d.manager_round, color: amber   },
  ];

  if (error && !data) {
    return (
      <Box sx={{ background: COLORS.background, minHeight: "100vh", p: 3, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, textAlign: "center", maxWidth: 420 }}>
          <Avatar sx={{ width: 56, height: 56, borderRadius: 2, background: "rgba(220,38,38,0.1)", mx: "auto", mb: 2 }}>
            <ErrorOutlineOutlined sx={{ fontSize: 28, color: "#dc2626" }} />
          </Avatar>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: COLORS.text, mb: 1 }}>Failed to load dashboard</Typography>
          <Typography sx={{ fontSize: 12, color: COLORS.card_txt_color, mb: 2.5, lineHeight: 1.6 }}>{error}</Typography>
          <Button variant="outlined" startIcon={<RefreshOutlined />} onClick={fetchDashboard}
            sx={{ borderColor: accent, color: accent, borderRadius: 2, textTransform: "none", fontWeight: 600 }}>
            Retry
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ background: COLORS.background, minHeight: "100vh", p: { xs: 2, md: 3 } }}>

      {error && data && (
        <Alert severity="warning" action={<Button size="small" onClick={fetchDashboard}>Retry</Button>}
          sx={{ mb: 2, borderRadius: 2, fontSize: 12 }}>
          Could not refresh data — showing last loaded values.
        </Alert>
      )}

      {/* ── Top bar ── */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Avatar sx={{ width: 40, height: 40, borderRadius: 2, background: accent }}>
            <PieChartOutlined sx={{ fontSize: 20, color: "white" }} />
          </Avatar>
          <Box>
            <Typography sx={{ fontSize: 16, fontWeight: 700, color: COLORS.text, lineHeight: 1.2 }}>
              Org Admin Dashboard
            </Typography>
            <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>
              {d.organization_id || "Organization Overview"}
            </Typography>
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          <Chip label={loading ? "Loading…" : "● Live"} size="small" sx={{
            fontSize: 11, fontWeight: 600, height: 24,
            background: loading ? "rgba(107,114,128,0.12)" : "rgba(22,163,74,0.12)",
            color: loading ? "#6b7280" : "#16a34a",
          }} />
          <Tooltip title="Refresh">
            <span>
              <IconButton onClick={fetchDashboard} disabled={loading} size="small" sx={{
                border: `1px solid ${COLORS.border}`, background: COLORS.cardBg,
                color: COLORS.text, borderRadius: 2, width: 34, height: 34,
              }}>
                <RefreshOutlined sx={{ fontSize: 16, ...(loading && { animation: "spin 1s linear infinite" }) }} />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}>
            <IconButton onClick={toggleTheme} size="small" sx={{
              border: `1px solid ${COLORS.border}`, background: COLORS.cardBg,
              color: COLORS.text, borderRadius: 2, width: 34, height: 34,
            }}>
              {theme === "dark" ? "☀️" : "🌙"}
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      {/* ── KPI Cards ── */}
      <SectionLabel COLORS={COLORS}>Overview metrics</SectionLabel>
      <Grid container spacing={1.5} mb={2.5}>
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <Grid item xs={6} sm={4} md={2} key={i}><MetricCardSkeleton COLORS={COLORS} /></Grid>
            ))
          : kpiCards.map((k) => (
              <Grid item xs={6} sm={4} md={2} key={k.label}>
                <MetricCard {...k} accentColor={k.color} COLORS={COLORS} />
              </Grid>
            ))
        }
      </Grid>

      {/* ── Middle row ── */}
      <Grid container spacing={1.5} mb={2.5}>

        {/* Completion Rate + Interview Rounds */}
        <Grid item xs={12} md={5}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text, mb: 2 }}>
                Interview Progress
              </Typography>

              {/* Gauge */}
              {loading
                ? <Stack direction="row" alignItems="center" gap={2} mb={2}>
                    <Skeleton variant="circular" width={96} height={96} />
                    <Box><Skeleton width={120} height={18} /><Skeleton width={160} height={13} sx={{ mt: 0.5 }} /></Box>
                  </Stack>
                : <Box mb={2.5}><CompletionGauge pct={Math.round(d.completion_rate_percentage)} accent={accent} COLORS={COLORS} /></Box>
              }

              <Divider sx={{ my: 2, borderColor: COLORS.border }} />

              <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1.4 }}>
                Round Breakdown
              </Typography>

              {loading
                ? [1,2,3,4].map((i) => (
                    <Box key={i} mb={1.6}><Skeleton width="50%" height={13} sx={{ mb: 0.5 }} /><Skeleton height={9} /></Box>
                  ))
                : roundRows.map((r) => (
                    <RoundRow key={r.label} label={r.label} value={r.value} max={maxRound} color={r.color} COLORS={COLORS} />
                  ))
              }
            </CardContent>
          </Card>
        </Grid>

        {/* Panel strength */}
        <Grid item xs={12} md={3}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text, mb: 2 }}>Panel Strength</Typography>

              {panelStats.map((s) => (
                <Stack key={s.label} direction="row" justifyContent="space-between" alignItems="center"
                  sx={{ py: 1.2, borderBottom: `0.5px solid ${COLORS.border}` }}>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 28, height: 28, borderRadius: 1.5, background: `${s.color}18` }}>
                      <s.icon sx={{ fontSize: 14, color: s.color }} />
                    </Avatar>
                    <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>{s.label}</Typography>
                  </Stack>
                  {loading
                    ? <Skeleton width={24} height={22} />
                    : <Typography sx={{ fontSize: 16, fontWeight: 700, color: COLORS.text }}>{s.value}</Typography>
                  }
                </Stack>
              ))}

              <Divider sx={{ my: 2, borderColor: COLORS.border }} />

              <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, background: `${green}10`, border: `1px solid ${green}22` }}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: green, mb: 0.4 }}>Hire vs Reject</Typography>
                {loading ? (
                  <Skeleton width="80%" height={13} />
                ) : (
                  <>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>Hired</Typography>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: green }}>{d.total_hire}</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between" mt={0.3}>
                      <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>Rejected</Typography>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: red }}>{d.total_rejected}</Typography>
                    </Stack>
                  </>
                )}
              </Paper>
            </CardContent>
          </Card>
        </Grid>

        {/* Interview Events */}
        <Grid item xs={12} md={4}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text, mb: 2 }}>Interview Events</Typography>

              {[
                { label: "Cancelled",    val: d.cancelled_interviews,    color: red,    icon: CancelOutlined   },
                { label: "Rescheduled",  val: d.rescheduled_interviews,  color: amber,  icon: LoopOutlined     },
                { label: "Scheduled",    val: d.scheduled,               color: purple, icon: EventNote        },
                { label: "Completed",    val: d.completed_rounds,        color: green,  icon: CheckCircleOutline },
              ].map((r) => (
                <Stack key={r.label} direction="row" justifyContent="space-between" alignItems="center"
                  sx={{ py: 1.1, borderBottom: `0.5px solid ${COLORS.border}` }}>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 28, height: 28, borderRadius: 1.5, background: `${r.color}18` }}>
                      <r.icon sx={{ fontSize: 14, color: r.color }} />
                    </Avatar>
                    <Typography sx={{ fontSize: 12, color: COLORS.card_txt_color }}>{r.label}</Typography>
                  </Stack>
                  {loading
                    ? <Skeleton width={28} height={22} variant="rounded" />
                    : <Chip label={r.val} size="small"
                        sx={{ height: 22, fontSize: 12, fontWeight: 700, background: `${r.color}18`, color: r.color }} />
                  }
                </Stack>
              ))}

              <Divider sx={{ my: 2, borderColor: COLORS.border }} />

              {/* Summary insight */}
              <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, background: `${accent}10`, border: `1px solid ${accent}22` }}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: accent, mb: 0.4 }}>Platform Health</Typography>
                <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, lineHeight: 1.6 }}>
                  {loading
                    ? "Checking status…"
                    : d.cancelled_interviews === 0 && d.rescheduled_interviews === 0
                      ? "All interviews are on track. No cancellations or rescheduling."
                      : `${d.cancelled_interviews} cancelled · ${d.rescheduled_interviews} rescheduled. Review pending interviews.`
                  }
                </Typography>
              </Paper>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* ── Pipeline summary bar ── */}
      <SectionLabel COLORS={COLORS}>Hiring pipeline</SectionLabel>
      <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, mb: 2 }}>
        <CardContent sx={{ p: 2.5 }}>
          <Grid container spacing={2} alignItems="center">
            {[
              { label: "Applications",    val: d.total_applications,  color: accent  },
              { label: "1st Round",       val: d.first_round,         color: purple  },
              { label: "2nd Round",       val: d.second_round,        color: teal    },
              { label: "HR Round",        val: d.hr_round,            color: amber   },
              { label: "Manager Round",   val: d.manager_round,       color: green   },
              { label: "Hired",           val: d.total_hire,          color: green   },
            ].map((stage, i, arr) => (
              <React.Fragment key={stage.label}>
                <Grid item xs={6} sm={4} md={2}>
                  <Box sx={{ textAlign: "center" }}>
                    {loading ? (
                      <><Skeleton variant="circular" width={44} height={44} sx={{ mx: "auto", mb: 0.5 }} /><Skeleton width={60} height={12} sx={{ mx: "auto" }} /></>
                    ) : (
                      <>
                        <Avatar sx={{ width: 44, height: 44, mx: "auto", mb: 0.5, background: `${stage.color}18`, fontSize: 16, fontWeight: 800, color: stage.color }}>
                          {stage.val}
                        </Avatar>
                        <Typography sx={{ fontSize: 10, color: COLORS.card_txt_color, textAlign: "center" }}>{stage.label}</Typography>
                      </>
                    )}
                  </Box>
                </Grid>
                {i < arr.length - 1 && (
                  <Grid item xs={0} sm={0} sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", color: COLORS.border, fontSize: 20 }}>
                    →
                  </Grid>
                )}
              </React.Fragment>
            ))}
          </Grid>
        </CardContent>
      </Card>

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </Box>
  );
}